import React from 'react';
import {Row,Col} from 'react-bootstrap';
import AddAddressModal from '../modals/AddAddressModal';
import DeleteAddressModal from '../modals/DeleteAddressModal';
import AddressCard from '../common/AddressCard';

const defaultAddresses = [
	{ id: 1, title: 'Home', icoIcon: 'ui-home', address: 'Osahan House, Jawaddi Kalan, Ludhiana, Punjab 141002, India', boxClass: 'border border-primary shadow' },
	{ id: 2, title: 'Work', icoIcon: 'briefcase', address: 'NCC, Model Town Rd, Pritm Nagar, Model Town, Ludhiana, Punjab 141002, India', boxClass: 'shadow-sm' },
	{ id: 3, title: 'Other', icoIcon: 'location-pin', address: 'Delhi Bypass Rd, Jawaddi Taksal, Ludhiana, Punjab 141002, India', boxClass: 'shadow-sm' },
	{ id: 4, title: 'Other', icoIcon: 'location-pin', address: 'MT, Model Town Rd, Pritm Nagar, Model Town, Ludhiana, Punjab 141002, India', boxClass: 'shadow-sm' },
	{ id: 5, title: 'Other', icoIcon: 'location-pin', address: 'GNE Rd, Jawaddi Taksal, Ludhiana, Punjab 141002, India', boxClass: 'shadow-sm' },
	{ id: 6, title: 'Other', icoIcon: 'location-pin', address: 'GTTT, Model Town Rd, Pritm Nagar, Model Town, Ludhiana, Punjab 141002, India', boxClass: 'shadow-sm' },
];

function loadAddresses() {
	const saved = localStorage.getItem("user-addresses");
	if (saved) {
		try { return JSON.parse(saved); } catch(e) { /* ignore */ }
	}
	return defaultAddresses;
}

class Addresses extends React.Component {
	constructor(props, context) {
	    super(props, context);

	    this.state = {
	      showDeleteModal: false,
      	  showAddressModal: false,
      	  addresses: loadAddresses(),
      	  deleteTargetId: null,
	    };
	}

    hideDeleteModal = () => this.setState({ showDeleteModal: false, deleteTargetId: null });
    hideAddressModal = () => this.setState({ showAddressModal: false });

    handleDelete = () => {
    	const { deleteTargetId, addresses } = this.state;
    	if (deleteTargetId == null) return;
    	const updated = addresses.filter(a => a.id !== deleteTargetId);
    	localStorage.setItem("user-addresses", JSON.stringify(updated));
    	this.setState({ addresses: updated, deleteTargetId: null });
    };

	render() {
    	return (
	      <>
	        <AddAddressModal show={this.state.showAddressModal} onHide={this.hideAddressModal}/>
	        <DeleteAddressModal show={this.state.showDeleteModal} onHide={this.hideDeleteModal} onDelete={this.handleDelete}/>
		    <div className='p-4 bg-white shadow-sm'>
              <Row>
               <Col md={12}>
                  <h4 className="font-weight-bold mt-0 mb-3">Manage Addresses</h4>
               </Col>
               {this.state.addresses.map(addr => (
               	  <Col md={6} key={addr.id}>
               	  	<AddressCard
               	  	  boxClass={addr.boxClass}
					  title={addr.title}
					  icoIcon={addr.icoIcon}
					  iconclassName='icofont-3x'
					  address={addr.address}
					  onEditClick={() => this.setState({ showAddressModal: true })}
					  onDeleteClick={() => this.setState({ showDeleteModal: true, deleteTargetId: addr.id })}
               	  	/>
               	  </Col>
               ))}
              </Row>
		    </div>
	      </>
    	);
    }
}
export default Addresses;
